// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/widgets/cookiesbar/cookiesbar.less
// module id = 1111
// module chunks = 10